import commonService from "./common-service";

class AddonsService {

    async getEOMAddons(year, month, start, next, searchText) {
        try {
            const response = await commonService.getFromServer(
                "EOM/Addons?" + 'year=' + year + '&month=' + month + '&start=' + start + '&next=' + next + '&search=' + searchText,
                {}
            );
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getEOMAddonsById(id) {
        try {
            const response = await commonService.getFromServer(
                "EOM/Addons/" + id,
                {}
            );
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async uploadAddonsDocument(year, month, params) {
        try {
            const response = await commonService.postToServer(
                "EOM/Addons/Upload?" + 'year=' + year + '&month=' + month,
                params
            );
            if (response) {
                return response;
            } else {
                throw new Error("Error uploading document");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async deleteAddonById(id) {
        try {
            const response = await commonService.deleteToServer(
                "EOM/" + id,
                {}
            );

            if (response) {
                return response;
            } else {
                throw new Error("Error deleting Addon");
            }
        } catch (e) {
            throw new Error("Error deleting Addon");
        }
    }
}

export default new AddonsService();
